import type { RaceStatus } from '../domain';

const dateFormatter = new Intl.DateTimeFormat('ko-KR', {
  month: 'long',
  day: 'numeric',
  weekday: 'short',
  timeZone: 'Asia/Seoul',
});

const dateTimeFormatter = new Intl.DateTimeFormat('ko-KR', {
  month: 'numeric',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
  timeZone: 'Asia/Seoul',
});

export const formatKoreanDate = (value: string): string =>
  dateFormatter.format(new Date(`${value}T00:00:00+09:00`));

export const formatDateTime = (value: string): string => dateTimeFormatter.format(new Date(value));

export const formatPrize = (value: number | null): string => {
  if (value === null) return '정보 없음';
  return `${new Intl.NumberFormat('ko-KR').format(value / 10000)}만원`;
};

export const formatRaceStatus = (status: RaceStatus): string => {
  if (status === 'scheduled') return '예정';
  if (status === 'awaiting_result') return '업데이트 대기';
  return '확정';
};

export const formatRank = (rank: number | null): string => (rank === null ? '기록 없음' : `${rank}위`);
